var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.45 14.6437H15.8813C15.1978 14.6437 14.6438 15.1978 14.6438 15.8812V21.45C14.6438 22.1334 15.1978 22.6875 15.8813 22.6875H21.45C22.1335 22.6875 22.6875 22.1334 22.6875 21.45V15.8812C22.6875 15.1978 22.1335 14.6437 21.45 14.6437Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1688 18.3563H11.55C11.2218 18.3563 10.907 18.2259 10.675 17.9938C10.4429 17.7617 10.3125 17.447 10.3125 17.1188V11.55C10.3125 11.2218 10.4429 10.907 10.675 10.675C10.907 10.4429 11.2218 10.3125 11.55 10.3125H17.1188C17.447 10.3125 17.7617 10.4429 17.9938 10.675C18.2259 10.907 18.3563 11.2218 18.3563 11.55V12.1688",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.85,
    height: 14.85,
    fill: "white",
    transform: "translate(9.07501 9.075)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySvg);
export default __webpack_public_path__ + "static/media/copy-svg.ff8b605647d64ee8df0ef477aef7d293.svg";
export { ForwardRef as ReactComponent };